import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListFranchiseManager from "../Components/Franchise Manager/listFranchiseManager";
import AddMasterFranchise from "../Components/Franchise Manager/addFranchiseManager";
import ViewFranchiseManager from "../Components/Franchise Manager/viewFranchiseManger";
import EditMasterFranchise from "../Components/Franchise Manager/editfranchiseManager";
import ViewFranchiseManagerAccessControl from "../Components/Franchise Manager/viewFranchiseManagerAccessControl";
import ListCityHeads from "../Components/Franchise Manager/listCityHeads";
import ListLocalityHeads from "../Components/Franchise Manager/listLocalityHeads";
import ListPartners from "../Components/Franchise Manager/listPartners";
import ViewPartner from "../Components/Franchise Manager/viewPartner";
import ListSiteVisits from "../Components/Franchise Manager/listSiteVisits";
import ListHomeVisits from "../Components/Franchise Manager/listHomeVisits";
import ViewVisit from "../Components/Franchise Manager/viewVisit";
import ViewFranchiseSiteVisit from "../Components/Franchise Manager/viewFranchiseSiteVisit";
import AddCityHead from "../Components/Franchise Manager/addCityHead";
import EditCityHead from "../Components/Franchise Manager/editCityHead";
import AddLocalityHead from "../Components/Franchise Manager/addLocalityHead";
import EditLocalityHead from "../Components/Franchise Manager/editLocalityHead";
import ListFranchiseProjects from "../Components/Franchise Manager/listFranchiseProjects";

const FranchiseManagerRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  return (
    <Routes>
      <Route path="/franchise" element={<ListFranchiseManager />} />
      {canAdd && <Route path="/franchise/add" element={<AddMasterFranchise />} />}
      <Route path="/franchise/view/:id" element={<ViewFranchiseManager />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/view" element={<ViewFranchiseManager />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads/:locality_head_id/view" element={<ViewFranchiseManager />} />
      {canEdit && <Route path="/franchise/edit/:id" element={<EditMasterFranchise />} />}
      <Route path="/franchise/access-control/:id" element={<ViewFranchiseManagerAccessControl />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/access-control" element={<ViewFranchiseManagerAccessControl />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads/:locality_head_id/access-control" element={<ViewFranchiseManagerAccessControl />} />
      <Route path="/franchise/:franchise_id/city-heads" element={<ListCityHeads />} />
      {canAdd && <Route path="/franchise/:franchise_id/city-heads/add" element={<AddCityHead />} />}
      {canEdit && <Route path="/franchise/:franchise_id/city-heads/:city_head_id/edit" element={<EditCityHead />} />}

      {canAdd && <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads/add" element={<AddLocalityHead />} />}
      {canEdit && <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads/:locality_head_id/edit" element={<EditLocalityHead />} />}
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads" element={<ListLocalityHeads />} />
      <Route path="/franchise/:franchise_id/partners" element={<ListPartners />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/partners" element={<ListPartners />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads/:locality_head_id/partners" element={<ListPartners />} />
      <Route path="/franchise/partner/view/:id" element={<ViewPartner />} />

      <Route path="/franchise/:franchise_id/site-visits" element={<ListSiteVisits />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/site-visits" element={<ListSiteVisits />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads/:locality_head_id/site-visits" element={<ListSiteVisits />} />

      <Route path="/franchise/:franchise_id/home-visits" element={<ListHomeVisits />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/home-visits" element={<ListHomeVisits />} />
      <Route path="/franchise/:franchise_id/city-heads/:city_head_id/locality-heads/:locality_head_id/home-visits" element={<ListHomeVisits />} />

      <Route path="/franchise/site-visit/view/:id" element={<ViewFranchiseSiteVisit isit type="site" />} />
      <Route path="/franchise/home-visit/view/:id" element={<ViewVisit type="home" />} />

      <Route path="/franchise/:franchise_id/projects" element={<ListFranchiseProjects />} />
    </Routes>
  );
};

export default FranchiseManagerRoutes;